
import { ReactNode, useMemo } from 'react';
import {
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query'
import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';

// Optimize QueryClient configuration for better performance
const createQueryClient = () => new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: DEFAULT_STALE_TIME,
            gcTime: DEFAULT_GC_TIME,
            refetchOnWindowFocus: false,
            retry: 1,
        },
        mutations: {
            retry: 1,
        },
    },
})

export const queryClient = createQueryClient()

export function Providers({ children }: { children: ReactNode }) {
    // Memoize the client to prevent recreation on re-renders
    const memoizedQueryClient = useMemo(() => queryClient, []);

    return (
        <QueryClientProvider client={memoizedQueryClient}>
            {children}
        </QueryClientProvider>
    );
}
